(() => {
  if (window.Eurus && window.Eurus.loadedScript) {
    if (window.Eurus.loadedScript.has('dev_custom.js')) return;
    window.Eurus.loadedScript.add('dev_custom.js');
  }

  const SELECTOR = '#cart-upsell-drawer';
  const DRAG_THRESHOLD = 4;

  let strip = null;
  let startX = 0;
  let startScroll = 0;
  let dragging = false;
  let moved = false;

  const stripFrom = (target) => (target && target.closest ? target.closest(SELECTOR) : null);

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    const el = stripFrom(event.target);
    if (!el) return;

    strip = el;
    dragging = true;
    moved = false;
    startX = event.clientX;
    startScroll = el.scrollLeft;
  });

  document.addEventListener('pointermove', (event) => {
    if (!dragging || !strip) return;

    const delta = event.clientX - startX;
    if (!moved) {
      if (Math.abs(delta) < DRAG_THRESHOLD) return;
      moved = true;
      strip.classList.add('is-dragging');
    }

    event.preventDefault();
    strip.scrollLeft = startScroll - delta;
  });

  const endDrag = () => {
    if (!strip) return;

    const el = strip;
    const wasDragged = moved;
    strip = null;
    dragging = false;
    moved = false;

    /* Kept one frame so the click closing a real drag does not open a product. */
    if (wasDragged) requestAnimationFrame(() => el.classList.remove('is-dragging'));
  };

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  document.addEventListener('wheel', (event) => {
    const el = stripFrom(event.target);
    if (!el) return;
    if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

    const maxScroll = el.scrollWidth - el.clientWidth;
    if (maxScroll <= 0) return;

    /* At either end the page keeps the wheel, so the drawer never feels stuck. */
    const atStart = el.scrollLeft <= 0 && event.deltaY < 0;
    const atEnd = el.scrollLeft >= maxScroll - 1 && event.deltaY > 0;
    if (atStart || atEnd) return;

    event.preventDefault();
    el.scrollLeft += event.deltaY;
  }, { passive: false });
})();

/* Cart gift option.
   Collects the recipient name and gift note in a panel, then puts the gift
   product in the cart carrying them as line item properties, so the data lands
   on the Shopify order rather than living only in the theme.

   Written here rather than reusing xCart.addShippingInsurance from theme.js:
   that method drives the xPopupInsurance store, which is only registered when
   shipping insurance is enabled, so calling it would throw on this store. */
document.addEventListener('alpine:init', () => {
  Alpine.store('xCartGift', {
    open: false,
    loading: false,
    error: '',

    /* Filled from the panel markup so the Liquid settings stay in one place. */
    variantId: null,
    recipientKey: 'Recipient name',
    recipientEmailKey: 'Recipient email',
    noteKey: 'Gift note',
    packingKey: 'Leave prices off the packing slip',
    packingValue: 'Yes',
    recipientRequired: false,
    noteRequired: false,
    requiredMessage: '',

    /* Form state */
    recipient: '',
    recipientEmail: '',
    note: '',
    hidePrices: false,
    editingLine: null,

    /* Header tracking handles, kept so they can be torn down on close */
    headerListener: null,
    headerObserver: null,

    configure(config) {
      Object.assign(this, config);
    },

    /* Single place that flips the panel, so the body scroll lock and the header
       measurement can never be left behind after a close, a confirm or a failed
       request. */
    setOpen(value) {
      this.open = value;
      document.body.classList.toggle('x-gift-panel-lock', value);
      if (value) {
        this.trackHeaderOffset();
      } else {
        this.untrackHeaderOffset();
      }
    },

    /* The panel sits under the header on phones. The theme's --height-header is
       0px until a sticky-header scroll event fires, so the header is measured
       directly instead. */
    measureHeaderOffset() {
      const header = document.getElementById('sticky-header-content');
      const bottom = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;
      document.documentElement.style.setProperty('--x-gift-panel-top', `${Math.round(bottom)}px`);
    },

    trackHeaderOffset() {
      this.measureHeaderOffset();
      if (this.headerListener) return;

      this.headerListener = () => this.measureHeaderOffset();
      window.addEventListener('resize', this.headerListener);
      window.addEventListener('scroll', this.headerListener, { passive: true });

      const header = document.getElementById('sticky-header-content');
      if (header && window.ResizeObserver) {
        this.headerObserver = new ResizeObserver(this.headerListener);
        this.headerObserver.observe(header);
      }
    },

    untrackHeaderOffset() {
      if (!this.headerListener) return;

      window.removeEventListener('resize', this.headerListener);
      window.removeEventListener('scroll', this.headerListener);
      this.headerObserver?.disconnect();
      this.headerObserver = null;
      this.headerListener = null;
    },

    openPanel() {
      this.recipient = '';
      this.recipientEmail = '';
      this.note = '';
      this.hidePrices = false;
      this.editingLine = null;
      this.error = '';
      this.setOpen(true);
    },

    edit(current) {
      this.recipient = current.recipient || '';
      this.recipientEmail = current.recipientEmail || '';
      this.note = current.note || '';
      this.hidePrices = !!current.hidePrices;
      this.editingLine = current.line;
      this.error = '';
      this.setOpen(true);
    },

    close() {
      if (this.loading) return;
      this.setOpen(false);
      this.error = '';
    },

    properties() {
      const properties = {};
      if (this.recipient.trim()) {
        properties[this.recipientKey] = this.recipient.trim();
        if (this.recipientKey !== 'Recipient name') {
          properties['Recipient name'] = this.recipient.trim();
        }
      }
      if (this.recipientEmail.trim()) {
        properties[this.recipientEmailKey] = this.recipientEmail.trim();
        if (this.recipientEmailKey !== 'Recipient email') {
          properties['Recipient email'] = this.recipientEmail.trim();
        }
      }
      // if (this.note.trim()) properties[this.noteKey] = this.note.trim();
      if (this.note.trim()) {
        properties[this.noteKey] = this.note.trim();
        properties['Message'] = this.note.trim();
      }
      if (this.hidePrices) properties[this.packingKey] = this.packingValue;
      return properties;
    },

    syncAttributes() {
      const attributes = {};
      if (this.recipient.trim()) attributes['Recipient Name'] = this.recipient.trim();
      if (this.recipientEmail.trim()) attributes['Recipient Email'] = this.recipientEmail.trim();
      if (this.note.trim()) attributes['Gift Note'] = this.note.trim();
      if (this.hidePrices) attributes['Leave prices off the packing slip'] = 'Yes';

      fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes })
      }).catch(() => {});
    },

    confirm() {
      if (this.loading) return;

      const missingRecipient = this.recipientRequired && !this.recipient.trim();
      const missingNote = this.noteRequired && !this.note.trim();
      if (missingRecipient || missingNote) {
        this.error = this.requiredMessage || 'Please fill in the required fields.';
        return;
      }

      if (this.recipientEmail.trim()) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.recipientEmail.trim())) {
          this.error = 'Please enter a valid email address.';
          return;
        }
      }

      this.error = '';
      return this.editingLine ? this._update() : this._add();
    },

    /* New gift: add the product with the properties attached. */
    _add() {
      this.loading = true;
      const helper = Alpine.store('xCartHelper');
      const items = [{ id: this.variantId, quantity: 1, properties: this.properties() }];

      this.syncAttributes();

      return helper.withCartLock(
        (standardEvent) => fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items,
            sections: helper.getSectionsToRender().map((section) => section.id)
          })
        })
          .then((response) => helper.cartJson(response))
          .then((response) => {
            if (response.status && Number(response.status) >= 400) {
              throw new Error(response.description || response.message);
            }
            helper.reRenderSections(response.sections);
            document.dispatchEvent(new CustomEvent('eurus:product:added', {
              detail: { product: response.items }
            }));
            this.setOpen(false);
            return helper.settleWithCart(standardEvent);
          })
          .catch((error) => {
            this.error = error.message || String(error);
            standardEvent.fail(error);
          })
          .finally(() => {
            this.loading = false;
          }),
        {
          type: 'shopify:cart:lines-add',
          action: 'add',
          context: 'cart',
          lines: [{ merchandiseId: this.variantId, quantity: 1 }]
        }
      );
    },

    /* Existing gift: change.js rewrites the properties on the line in place,
       so the customer keeps one gift line instead of a remove-then-add pair. */
    _update() {
      this.loading = true;
      const helper = Alpine.store('xCartHelper');
      const line = this.editingLine;

      this.syncAttributes();

      return helper.withCartLock(
        (standardEvent) => fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line,
            quantity: 1,
            properties: this.properties(),
            sections: helper.getSectionsToRender().map((section) => section.id)
          })
        })
          .then((response) => helper.cartJson(response))
          .then((response) => {
            if (response.status && Number(response.status) >= 400) {
              throw new Error(response.description || response.message);
            }
            helper.reRenderSections(response.sections);
            this.setOpen(false);
            return helper.settleWithCart(standardEvent);
          })
          .catch((error) => {
            this.error = error.message || String(error);
            standardEvent.fail(error);
          })
          .finally(() => {
            this.loading = false;
          }),
        {
          type: 'shopify:cart:lines-update',
          action: 'update',
          context: 'cart',
          lines: [{ id: String(line), quantity: 1 }]
        }
      );
    }
  });
});



window.essentialUpsellBypassInterception = true;

(() => {
  const dismissStrayUpsell = () => {
    document.querySelectorAll('dialog[id^="essential-upsell-popup-dialog"]').forEach((d) => {
      try { d.close(); } catch (e) {}
      d.remove();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dismissStrayUpsell);
  } else {
    dismissStrayUpsell();
  }
  if (window.MutationObserver) {
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.tagName === 'DIALOG' && node.id && node.id.startsWith('essential-upsell-popup-dialog')) {
            try { node.close(); } catch (e) {}
            node.remove();
          }
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();



/* Expanded 2-Column Cart Drawer State */
(() => {
  const isCartEmpty = () => {
    const countBubble = document.getElementById('cart-icon-bubble');
    if (countBubble) {
      const countItem = countBubble.querySelector('.count_item');
      if (countItem) {
        if (countItem.classList.contains('hidden')) return true;
        const count = parseInt(countItem.textContent.trim() || '0');
        if (!isNaN(count) && count === 0) return true;
        if (!isNaN(count) && count > 0) return false;
      }
    }
    const mobileDockBubble = document.getElementById('cart-icon-bubble-mobile-dock');
    if (mobileDockBubble) {
      const val = parseInt(mobileDockBubble.getAttribute('data-value') || mobileDockBubble.textContent.trim() || '0');
      if (!isNaN(val) && val === 0) return true;
      if (!isNaN(val) && val > 0) return false;
    }
    const helper = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
    if (helper && typeof helper.currentItemCount === 'number') {
      if (helper.currentItemCount === 0) return true;
      if (helper.currentItemCount > 0) return false;
    }
    const updateCart = document.getElementById('update-cart');
    if (updateCart) {
      if (updateCart.querySelector('.cartpopup-body')) return true;
      if (updateCart.querySelector('.cartpopup-content.not-empty') || updateCart.querySelector('.cart-item')) return false;
    }
    return false;
  };

  // Track header/dock cart icon clicks as a safeguard
  document.addEventListener('click', (e) => {
    const cartTrigger = e.target.closest('#cart-icon, .header-icon-cart, a[href*="/cart"]');
    if (cartTrigger && !cartTrigger.closest('#update-cart, #CartDrawer, .cart-popup-content, .cart-expanded-summary-col')) {
      window._headerCartClicked = true;
    }
  }, true);

  const initMiniCartExpanded = () => {
    if (window.Alpine && Alpine.store && Alpine.store('xMiniCart')) {
      const store = Alpine.store('xMiniCart');
      if (store._expandedCustomPatched) return;
      store._expandedCustomPatched = true;

      if (store.isExpanded === undefined) {
        store.isExpanded = false;
      }

      const origHideCart = store.hideCart;
      store.hideCart = function() {
        this.isExpanded = false;
        window._cartExpandedLock = false;
        window._headerCartClicked = false;
        const updateCart = document.getElementById('update-cart');
        if (updateCart) {
          updateCart.classList.remove('cart-drawer--expanded');
          if (updateCart._x_dataStack && updateCart._x_dataStack[0]) {
            updateCart._x_dataStack[0].isExpanded = false;
          }
        }
        return origHideCart ? origHideCart.apply(this, arguments) : undefined;
      };

      const origOpenCart = store.openCart;
      store.openCart = function(expand) {
        const fromHeader = window._headerCartClicked === true;
        window._headerCartClicked = false;

        const shouldExpand = (expand === true || fromHeader) && !isCartEmpty();

        const updateCart = document.getElementById('update-cart');
        if (shouldExpand) {
          this.isExpanded = true;
          window._cartExpandedLock = true;
          if (updateCart) {
            updateCart.classList.add('cart-drawer--expanded');
            if (updateCart._x_dataStack && updateCart._x_dataStack[0]) {
              updateCart._x_dataStack[0].isExpanded = true;
            }
          }
        } else {
          this.isExpanded = false;
          window._cartExpandedLock = false;
          if (updateCart) {
            updateCart.classList.remove('cart-drawer--expanded');
            if (updateCart._x_dataStack && updateCart._x_dataStack[0]) {
              updateCart._x_dataStack[0].isExpanded = false;
            }
          }
        }
        return origOpenCart ? origOpenCart.apply(this, arguments) : undefined;
      };
    }
  };

  if (window.Alpine && Alpine.store) {
    initMiniCartExpanded();
  } else {
    document.addEventListener('alpine:init', initMiniCartExpanded);
  }
  document.addEventListener('alpine:initialized', initMiniCartExpanded);
})();

/* Preserve isExpanded state across cart section re-renders.
   When qty changes, reRenderSections replaces #CartDrawer innerHTML,
   which resets Alpine's local isExpanded to false and collapses
   the 2-column view. We patch it to save/restore the state. */
(() => {
  const patchReRenderSections = () => {
    if (!window.Alpine || !Alpine.store || !Alpine.store('xCartHelper')) return;

    const helper = Alpine.store('xCartHelper');
    if (helper._expandedPatchApplied) return;
    helper._expandedPatchApplied = true;

    const origReRender = helper.reRenderSections.bind(helper);

    helper.reRenderSections = async function(sections) {
      /* Capture current expanded state before re-render */
      let wasExpanded = false;
      try {
        const updateCart = document.getElementById('update-cart');
        if (updateCart) {
          /* Most reliable: check the CSS class that Alpine binds */
          wasExpanded = updateCart.classList.contains('cart-drawer--expanded');
          /* Fallback: Alpine data stack */
          if (!wasExpanded && updateCart._x_dataStack) {
            const data = updateCart._x_dataStack[0];
            if (data && typeof data.isExpanded === 'boolean') {
              wasExpanded = data.isExpanded;
            }
          }
        }
        if (!wasExpanded && Alpine.store('xMiniCart') && Alpine.store('xMiniCart').isExpanded) {
          wasExpanded = true;
        }
      } catch (e) {}

      /* Check if incoming sections indicate the cart will be empty */
      let willBeEmpty = false;
      if (sections && sections['cart-drawer']) {
        const drawerHtml = sections['cart-drawer'];
        if (drawerHtml.includes('cartpopup-body') || !drawerHtml.includes('cart-item')) {
          willBeEmpty = true;
        }
      }

      if (willBeEmpty) {
        wasExpanded = false;
        window._cartExpandedLock = false;
        if (Alpine.store('xMiniCart')) {
          Alpine.store('xMiniCart').isExpanded = false;
        }
      } else if (wasExpanded) {
        window._cartExpandedLock = true;
      }

      await origReRender(sections);

      const checkEmpty = () => {
        const updateCart = document.getElementById('update-cart');
        if (!updateCart) return true;
        if (updateCart.querySelector('.cartpopup-body')) return true;
        if (!updateCart.querySelector('.cart-item')) return true;
        const countBubble = document.getElementById('cart-icon-bubble');
        if (countBubble && parseInt(countBubble.textContent.trim() || '0') === 0) return true;
        return false;
      };

      if (checkEmpty()) {
        window._cartExpandedLock = false;
        const updateCart = document.getElementById('update-cart');
        if (updateCart) {
          updateCart.classList.remove('cart-drawer--expanded');
          if (updateCart._x_dataStack && updateCart._x_dataStack[0]) {
            updateCart._x_dataStack[0].isExpanded = false;
          }
        }
        if (Alpine.store('xMiniCart')) {
          Alpine.store('xMiniCart').isExpanded = false;
        }
        return;
      }

      /* After re-render, restore Alpine data and clear the lock ONLY if not empty */
      if (wasExpanded) {
        const clearLockAndSync = (attempts) => {
          if (checkEmpty()) {
            window._cartExpandedLock = false;
            const updateCart = document.getElementById('update-cart');
            if (updateCart) {
              updateCart.classList.remove('cart-drawer--expanded');
              if (updateCart._x_dataStack && updateCart._x_dataStack[0]) {
                updateCart._x_dataStack[0].isExpanded = false;
              }
            }
            if (Alpine.store('xMiniCart')) {
              Alpine.store('xMiniCart').isExpanded = false;
            }
            return;
          }
          if (attempts <= 0) {
            window._cartExpandedLock = false;
            return;
          }
          try {
            const updateCart = document.getElementById('update-cart');
            if (updateCart && updateCart._x_dataStack) {
              const data = updateCart._x_dataStack[0];
              if (data && typeof data.isExpanded === 'boolean') {
                data.isExpanded = true;
              }
            }
            if (Alpine.store('xMiniCart')) {
              Alpine.store('xMiniCart').isExpanded = true;
            }
          } catch (e) {}
          /* Keep retrying until Alpine is ready, then clear the lock */
          if (attempts > 1) {
            requestAnimationFrame(() => clearLockAndSync(attempts - 1));
          } else {
            window._cartExpandedLock = false;
          }
        };
        requestAnimationFrame(() => clearLockAndSync(8));
      }
    };
  };

  /* Run after Alpine is ready and store is populated */
  const tryPatch = () => {
    if (window.Alpine && Alpine.store && Alpine.store('xCartHelper')) {
      patchReRenderSections();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(tryPatch, 500));
  } else {
    setTimeout(tryPatch, 500);
  }
  document.addEventListener('alpine:initialized', () => setTimeout(tryPatch, 100));

  /* Collapse back to standard ADDED TO BAG mini-cart if cart becomes empty */
  document.addEventListener('eurus:cart:items-changed', () => {
    const updateCart = document.getElementById('update-cart');
    const isEmpty = !updateCart || updateCart.querySelector('.cartpopup-body') !== null || !updateCart.querySelector('.cart-item');
    if (isEmpty) {
      window._cartExpandedLock = false;
      if (updateCart) {
        updateCart.classList.remove('cart-drawer--expanded');
        if (updateCart._x_dataStack && updateCart._x_dataStack[0]) {
          updateCart._x_dataStack[0].isExpanded = false;
        }
      }
      if (window.Alpine && Alpine.store && Alpine.store('xMiniCart')) {
        Alpine.store('xMiniCart').isExpanded = false;
      }
    }
  });
})();




/* Auto-open Cart Drawer when redirected from /cart*/
(() => {
  const checkAndOpenCart = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('open_cart') !== 'true') return;

    // Remove ?open_cart=true from address bar cleanly without page refresh
    params.delete('open_cart');
    const cleanSearch = params.toString();
    const cleanUrl = window.location.pathname + (cleanSearch ? '?' + cleanSearch : '') + window.location.hash;
    window.history.replaceState({}, '', cleanUrl);

    // Ensure cart drawer HTML is fetched via init-run
    window.dispatchEvent(new CustomEvent('init-run'));

    // Trigger cart drawer to open
    const triggerOpen = () => {
      if (window.Alpine && Alpine.store && Alpine.store('xMiniCart')) {
        const updateCart = document.getElementById('update-cart') || document.getElementById('CartDrawer');
        if (updateCart) {
          if (Alpine.store('xModal')) {
            Alpine.store('xModal').setActiveElement('cart-icon');
          }
          Alpine.store('xMiniCart').openCart(true);
          return true;
        }
      }
      return false;
    };

    if (!triggerOpen()) {
      let attempts = 0;
      const pollTimer = setInterval(() => {
        attempts++;
        if (triggerOpen() || attempts > 40) {
          clearInterval(pollTimer);
        }
      }, 100);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndOpenCart);
  } else {
    checkAndOpenCart();
  }
})();




/* ==========================================================================
   Aamra Cart & Global Wishlist Integration (Optimized & Non-blocking)
   - Handles text button "WISHLIST" <-> "MOVED TO WISHLIST" in cart drawer and /cart page
   - Prevents double click / conflicting add+remove notifications
   - Persists state across page load and refresh via localStorage cache & Wishlist Engine sync
   - Fast, debounced, zero DOM thrashing, zero recursive mutation loops
   ========================================================================== */
(() => {
  const ENGINE_SELECTOR = '.wishlist-engine[data-product_id]';
  const CART_WRAP_SELECTOR = '.aamra-cart-wishlist-wrap';
  const STORAGE_KEY = 'aamra_wishlist_ids';

   const CUSTOM_HEART_UNFILL = '<svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.5087 1.48764C17.5548 0.540811 16.2626 0.0084515 14.915 0.00709622C13.5673 0.00574094 12.274 0.5355 11.3182 1.4804L10.0022 2.69887L8.68626 1.4804C7.73116 0.531671 6.43626 -0.000846576 5.08641 1.01025e-06C3.73656 0.000848596 2.44233 0.534992 1.48844 1.48492C0.534558 2.43486 -0.000851153 3.72277 1.01569e-06 5.06533C0.000853185 6.40789 0.537897 7.69512 1.49299 8.64386L9.61416 16.8387C9.66488 16.8898 9.7253 16.9303 9.79192 16.958C9.85853 16.9857 9.93002 17 10.0022 17C10.0744 17 10.1459 16.9857 10.2125 16.958C10.2791 16.9303 10.3396 16.8898 10.3903 16.8387L18.5087 8.64747C18.9815 8.17741 19.3565 7.61931 19.6124 7.00506C19.8683 6.39081 20 5.73244 20 5.06755C20 4.40267 19.8683 3.7443 19.6124 3.13004C19.3565 2.51579 18.9815 1.9577 18.5087 1.48764ZM17.7344 7.88277L10.0022 15.6853L2.2673 7.88006C1.52175 7.13334 1.10413 6.12317 1.10594 5.07081C1.10774 4.01846 1.52881 3.00971 2.27692 2.26553C3.02503 1.52134 4.03919 1.10238 5.09726 1.10042C6.15532 1.09845 7.17105 1.51365 7.92194 2.25505C7.92636 2.25974 7.93123 2.26398 7.93648 2.26771L9.63051 3.83689C9.73145 3.93041 9.86427 3.98242 10.0022 3.98242C10.1402 3.98242 10.273 3.93041 10.3739 3.83689L12.068 2.2668C12.0732 2.26307 12.0781 2.25884 12.0825 2.25415C12.4536 1.8829 12.8946 1.58816 13.3805 1.38683C13.8663 1.1855 14.3873 1.08154 14.9136 1.08091C15.4399 1.08028 15.9612 1.183 16.4475 1.38317C16.9338 1.58334 17.3756 1.87702 17.7476 2.24738C18.1195 2.61774 18.4143 3.05749 18.615 3.5414C18.8157 4.02531 18.9184 4.54387 18.9172 5.06734C18.916 5.59081 18.8109 6.10889 18.6079 6.59187C18.4049 7.07485 18.1081 7.51323 17.7344 7.88186V7.88277Z" fill="currentColor"/></svg>';
  const CUSTOM_HEART_FILL = '<svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.5087 1.48764C17.5548 0.540811 16.2626 0.0084515 14.915 0.00709622C13.5673 0.00574094 12.274 0.5355 11.3182 1.4804L10.0022 2.69887L8.68626 1.4804C7.73116 0.531671 6.43626 -0.000846576 5.08641 1.01025e-06C3.73656 0.000848596 2.44233 0.534992 1.48844 1.48492C0.534558 2.43486 -0.000851153 3.72277 1.01569e-06 5.06533C0.000853185 6.40789 0.537897 7.69512 1.49299 8.64386L9.61416 16.8387C9.66488 16.8898 9.7253 16.9303 9.79192 16.958C9.85853 16.9857 9.93002 17 10.0022 17C10.0744 17 10.1459 16.9857 10.2125 16.958C10.2791 16.9303 10.3396 16.8898 10.3903 16.8387L18.5087 8.64747C18.9815 8.17741 19.3565 7.61931 19.6124 7.00506C19.8683 6.39081 20 5.73244 20 5.06755C20 4.40267 19.8683 3.7443 19.6124 3.13004C19.3565 2.51579 18.9815 1.9577 18.5087 1.48764Z" fill="currentColor"/></svg>';

  if (!window.customHeartIcon) window.customHeartIcon = CUSTOM_HEART_UNFILL;
  if (!window.customHeartFillIcon) window.customHeartFillIcon = CUSTOM_HEART_FILL;

  const sanitizeWishlistIcons = (root = document) => {
    const engines = root.querySelectorAll ? root.querySelectorAll(ENGINE_SELECTOR) : [];
    engines.forEach((container) => {
      if (container.closest('.aamra-cart-item-actions') || container.closest(CART_WRAP_SELECTOR)) return;
      const svg = container.querySelector('svg');
      if (!svg) return;
      const pathD = svg.querySelector('path')?.getAttribute('d') || '';
      if (pathD.includes('12.4869') || svg.getAttribute('viewBox') === '0 0 25 22') {
        const isAdded = container.getAttribute('data-added') === 'true';
        const iconHtml = isAdded ? (window.customHeartFillIcon || CUSTOM_HEART_FILL) : (window.customHeartIcon || CUSTOM_HEART_UNFILL);
        const iconSpan = container.querySelector('.wishlist-icon');
        if (iconSpan) {
          iconSpan.innerHTML = iconHtml;
        } else {
          const btn = container.querySelector('button, .wishlist-engine-button');
          if (btn) btn.innerHTML = iconHtml;
        }
      }
    });
  };

  // In-memory cache for wishlist IDs to avoid repeated disk reads/writes
  let memoryWishlistSet = null;

  const getStoredIds = () => {
    if (!memoryWishlistSet) {
      try {
        const data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        memoryWishlistSet = Array.isArray(data) ? new Set(data.map(String)) : new Set();
      } catch (e) {
        memoryWishlistSet = new Set();
      }
    }
    return memoryWishlistSet;
  };

  const updateStorage = (productId, isAdded) => {
    if (!productId) return;
    const set = getStoredIds();
    const idStr = String(productId);
    if (isAdded) {
      set.add(idStr);
    } else {
      set.delete(idStr);
    }
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(set)));
    } catch (e) {}
  };

  // Pure read-only check: O(1) in-memory check without touching DOM or disk
  const isProductWishlisted = (productId, wrap) => {
    if (!productId) return false;
    const idStr = String(productId);

    // 1. Check wrap's own engine attribute if present
    if (wrap) {
      const eng = wrap.querySelector('.wishlist-engine');
      if (eng) {
        const added = eng.getAttribute('data-added');
        if (added === 'true' || added === '1') return true;
        if (added === 'false' || added === '0') return false;
      }
    }

    // 2. Check in-memory cached state
    return getStoredIds().has(idStr);
  };

  // Update a single cart button UI (only modifies if text or class differs)
  const setButtonState = (btn, isAdded) => {
    if (!btn) return;
    const span = btn.querySelector('.aamra-cart-wishlist-text');
    if (isAdded) {
      if (!btn.classList.contains('is-moved')) btn.classList.add('is-moved');
      if (span && span.textContent !== 'Moved to Wishlist') span.textContent = 'Moved to Wishlist';
      btn.setAttribute('aria-label', 'Remove from wishlist');
    } else {
      if (btn.classList.contains('is-moved')) btn.classList.remove('is-moved');
      if (span && span.textContent !== 'WISHLIST') span.textContent = 'WISHLIST';
      btn.setAttribute('aria-label', 'Add to wishlist');
    }
  };

  // Synchronize cart buttons without modifying .wishlist-engine (prevents mutation loops)
  const syncCartWishlistButtons = (targetProductId, explicitState) => {
    const wraps = document.querySelectorAll(CART_WRAP_SELECTOR);
    if (!wraps.length) return;

    wraps.forEach((wrap) => {
      const prodId = wrap.getAttribute('data-product_id') ||
                     wrap.querySelector('.wishlist-engine')?.getAttribute('data-product_id') ||
                     wrap.querySelector('.aamra-cart-wishlist-btn')?.getAttribute('data-product_id');
      if (!prodId) return;
      if (targetProductId && String(prodId) !== String(targetProductId)) return;

      const isAdded = (typeof explicitState === 'boolean')
        ? explicitState
        : isProductWishlisted(prodId, wrap);

      const btn = wrap.querySelector('.aamra-cart-wishlist-btn');
      setButtonState(btn, isAdded);
    });
  };

  // Debounce sync calls with requestAnimationFrame
  let syncScheduled = false;
  const scheduleSync = () => {
    if (syncScheduled) return;
    syncScheduled = true;
    requestAnimationFrame(() => {
      syncScheduled = false;
      syncCartWishlistButtons();
    });
  };

  // Mirror non-cart duplicate engines without triggering recursive loops
  let isMirroring = false;
  const mirror = (source) => {
    const id = source.getAttribute('data-product_id');
    const added = source.getAttribute('data-added');
    if (!id || added === null) return;

    const isAdded = (added === 'true' || added === '1');
    updateStorage(id, isAdded);

    // Sync only cart buttons for this specific product ID
    const wraps = document.querySelectorAll(CART_WRAP_SELECTOR);
    wraps.forEach((w) => {
      const pId = w.getAttribute('data-product_id') ||
                  w.querySelector('.wishlist-engine')?.getAttribute('data-product_id');
      if (pId && String(pId) === String(id)) {
        setButtonState(w.querySelector('.aamra-cart-wishlist-btn'), isAdded);
      }
    });

    // Mirror non-cart duplicate cards
    isMirroring = true;
    document.querySelectorAll(ENGINE_SELECTOR).forEach((target) => {
      if (target === source) return;
      if (target.getAttribute('data-product_id') !== id) return;
      if (target.closest('.aamra-cart-item-actions') || target.closest(CART_WRAP_SELECTOR)) return;
      if (source.closest('.aamra-cart-item-actions') || source.closest(CART_WRAP_SELECTOR)) return;

      if (target.getAttribute('data-added') === added && target.innerHTML === source.innerHTML) return;

      target.setAttribute('data-added', added);
      target.innerHTML = source.innerHTML;
    });
    isMirroring = false;
    setTimeout(() => {
      isMirroring = false;
    }, 0);
  };

  // Moving to the wishlist takes the line out of the cart, but only once the app has saved it.
  // Saves can take over 10s, so the button stays locked until the app answers or SAVE_TIMEOUT passes.
  const SAVE_TIMEOUT = 30000;
  const removeLineAfterSave = (wrap, btn, productId) => {
    const engine = wrap?.querySelector('.wishlist-engine');
    const removeBtn = wrap?.closest('.aamra-cart-item-actions')?.querySelector('.aamra-cart-remove-btn');
    if (!engine || !removeBtn) return;

    const finish = () => {
      observer.disconnect();
      clearTimeout(timer);
      btn.removeAttribute('data-wishlist-saving');
    };
    const observer = new MutationObserver(() => {
      if (engine.getAttribute('data-added') !== 'true') return;
      finish();
      removeBtn.click();
    });
    const timer = setTimeout(() => {
      finish();
      updateStorage(productId, false);
      setButtonState(btn, false);
    }, SAVE_TIMEOUT);

    btn.setAttribute('data-wishlist-saving', 'true');
    observer.observe(engine, { attributes: true, attributeFilter: ['data-added'] });
  };

  // The app ignores clicks until it has loaded, which can take several seconds after page load.
  // Hold a click made in that window and replay it, unless the product turns out to be saved already.
  const CLICK_HOLD_TIMEOUT = 15000;
  document.addEventListener('click', (e) => {
    const engine = e.target.closest(ENGINE_SELECTOR);
    if (!engine || engine.hasAttribute('data-added') || engine.hasAttribute('data-click-held')) return;

    engine.setAttribute('data-click-held', 'true');
    engine.style.opacity = '0.5';

    const release = () => {
      observer.disconnect();
      clearTimeout(timer);
      engine.removeAttribute('data-click-held');
      engine.style.opacity = '';
    };
    const observer = new MutationObserver(() => {
      if (!engine.hasAttribute('data-added')) return;
      release();
      if (engine.getAttribute('data-added') === 'false') engine.click();
    });
    const timer = setTimeout(release, CLICK_HOLD_TIMEOUT);
    observer.observe(engine, { attributes: true, attributeFilter: ['data-added'] });
  });

  // Delegated Click Handler for Cart Wishlist Button
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.aamra-cart-wishlist-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    // Prevent rapid multiple clicks while Wishlist Engine processes
    if (btn.hasAttribute('data-wishlist-busy') || btn.hasAttribute('data-wishlist-saving')) return;
    btn.setAttribute('data-wishlist-busy', 'true');
    setTimeout(() => {
      btn.removeAttribute('data-wishlist-busy');
    }, 1000);

    const wrap = btn.closest(CART_WRAP_SELECTOR) || btn.parentElement;
    const productId = btn.getAttribute('data-product_id') ||
                      wrap?.getAttribute('data-product_id') ||
                      wrap?.querySelector('.wishlist-engine')?.getAttribute('data-product_id');

    // Check current state: is it currently moved to wishlist?
    const span = btn.querySelector('.aamra-cart-wishlist-text');
    const currentText = (span?.textContent || '').trim().toUpperCase();
    const isCurrentlyMoved = btn.classList.contains('is-moved') || currentText === 'MOVED TO WISHLIST';

    // Toggle: if currently moved -> remove (false); if not moved -> add (true)
    const nextState = !isCurrentlyMoved;

    // Immediately update button UI and in-memory/disk cache
    if (productId) {
      updateStorage(productId, nextState);
      const allWraps = document.querySelectorAll(CART_WRAP_SELECTOR);
      allWraps.forEach((w) => {
        const pId = w.getAttribute('data-product_id') ||
                    w.querySelector('.wishlist-engine')?.getAttribute('data-product_id') ||
                    w.querySelector('.aamra-cart-wishlist-btn')?.getAttribute('data-product_id');
        if (pId && String(pId) === String(productId)) {
          setButtonState(w.querySelector('.aamra-cart-wishlist-btn'), nextState);
        }
      });
    } else {
      setButtonState(btn, nextState);
    }

    if (nextState) removeLineAfterSave(wrap, btn, productId);

    // Trigger Wishlist Engine action EXACTLY ONCE
    const engineBtn = wrap?.querySelector('.wishlist-engine-button');
    if (engineBtn && engineBtn !== btn) {
      engineBtn.click();
    } else if (productId) {
      const otherBtn = document.querySelector(`.wishlist-engine[data-product_id="${productId}"] .wishlist-engine-button`);
      if (otherBtn) {
        otherBtn.click();
      }
    }
  });

  // Watch for Wishlist Engine mutations on collection cards
 const startObserver = () => {
    const observer = new MutationObserver((mutations) => {
      if (isMirroring) return;
      let hasMutations = false;
      const sources = new Set();
      for (let i = 0; i < mutations.length; i++) {
        const node = mutations[i].target;
        if (!node || node.nodeType !== 1) continue;
        const container = node.closest ? node.closest(ENGINE_SELECTOR) : null;
        if (container) {
          sources.add(container);
          hasMutations = true;
        }
      }
      sources.forEach(mirror);
      if (hasMutations) sanitizeWishlistIcons();
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-added']
    });
  };

  // Initial synchronization
  const initSync = () => {
    syncCartWishlistButtons();
    sanitizeWishlistIcons();
    startObserver();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSync);
  } else {
    initSync();
  }

  // React to cart events with debounced scheduleSync (no WishlistEngine reboot or heavy loops)
  document.addEventListener('eurus:cart:items-changed', scheduleSync);
  document.addEventListener('eurus:cart:reload', scheduleSync);
})();



// Automatically remove srcset and sizes across all images (initial load + dynamic components)
// Phones (<768px) keep srcset with a measured size instead, so they don't download 1500-3840px files
(() => {
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  const stripSrcset = (img) => {
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
  };

  // CSS width the image must cover: object-fit cover crops, so a tall box needs a wider file
  const cssWidthNeeded = (img, rect) => {
    if (getComputedStyle(img).objectFit !== 'cover') return rect.width;
    const w = +img.getAttribute('width');
    const h = +img.getAttribute('height');
    return w && h ? Math.max(rect.width, rect.height * w / h) : 0;
  };

  const sizeForMobile = (images) => {
    const dpr = window.devicePixelRatio || 1;
    const plan = [];
    // read everything first, then write, so layout is computed once
    for (let i = 0; i < images.length; i++) {
      const img = images[i];
      if (img.dataset.aamraSized) continue;
      if (!img.getAttribute('srcset')) { plan.push([img, 'strip']); continue; }
      const rect = img.getBoundingClientRect();
      const current = img.currentSrc;
      if (!rect.width || !rect.height) {
        // hidden (e.g. 2nd card image): can't measure, so allow up to full screen width;
        // if already downloaded, changing it would only download it again
        plan.push([img, current ? 'keep' : Math.ceil(window.innerWidth) + 'px']);
        continue;
      }
      const cssNeed = cssWidthNeeded(img, rect);
      if (!cssNeed) { plan.push([img, 'strip']); continue; }
      const match = current && current.match(/[?&]width=(\d+)/);
      const got = current ? (match ? +match[1] : Infinity) : 0;
      plan.push([img, got >= cssNeed * dpr ? 'keep' : Math.ceil(cssNeed) + 'px']);
    }
    for (let i = 0; i < plan.length; i++) {
      const [img, action] = plan[i];
      if (action === 'strip') {
        stripSrcset(img);
      } else {
        if (action !== 'keep') img.setAttribute('sizes', action);
        img.dataset.aamraSized = '1';
      }
    }
  };

  const removeSrcsets = (root) => {
    const context = root && root.querySelectorAll ? root : document;
    const images = context.querySelectorAll('img[srcset], img[sizes]');
    if (mobileQuery.matches) {
      sizeForMobile(images);
      return;
    }
    for (let i = 0; i < images.length; i++) {
      if (images[i].closest('.aamra-desktop-media-wrapper, [id^="stacked-"]')) continue;
      stripSrcset(images[i]);
    }
  };

  // Rotating or resizing past 768px falls back to the desktop behaviour
  const onQueryChange = (e) => { if (!e.matches) removeSrcsets(); };
  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onQueryChange);
  else if (mobileQuery.addListener) mobileQuery.addListener(onQueryChange);

  // 1. Initial removal
  removeSrcsets();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => removeSrcsets());
  }

  // 2. Debounced runner for dynamic components (cart drawer, AJAX, filters)
  let rafId = null;
  const scheduleRemoveSrcsets = () => {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      removeSrcsets();
    });
  };

  // 3. MutationObserver for dynamic images (childList only, no attribute ping-pong)
  const observer = new MutationObserver((mutations) => {
    for (let i = 0; i < mutations.length; i++) {
      const added = mutations[i].addedNodes;
      if (added && added.length > 0) {
        let isGalleryMutation = false;
        for (let j = 0; j < added.length; j++) {
          const node = added[j];
          if (node.nodeType === 1 && (
            (node.classList && node.classList.contains('product-media-item')) ||
            (node.id && node.id.startsWith('postion-image-')) ||
            (node.closest && node.closest('.aamra-desktop-media-wrapper, [id^="stacked-"]'))
          )) {
            isGalleryMutation = true;
            break;
          }
        }
        if (isGalleryMutation) continue;
        scheduleRemoveSrcsets();
        break;
      }
    }
  });

  const rootElement = document.documentElement || document.body;
  if (rootElement) {
    observer.observe(rootElement, {
      childList: true,
      subtree: true
    });
  }

  // 4. Also listen to relevant theme events
  document.addEventListener('shopify:section:load', scheduleRemoveSrcsets);
  document.addEventListener('eurus:cart:items-changed', scheduleRemoveSrcsets);
})();











// Product Grid Listing Image Hover State Handler
// Adds hover classes strictly to product cards and image containers within the "Product grid" listing section
(() => {
  const HOVER_CLASSES = ['is-image-hovered', 'is-hovered', 'image-hovered'];
  let activeContext = null;

  const getImageContext = (target) => {
    if (!target || !target.closest) return null;

    // Restrict strictly to the "Product grid" listing section and Recently Viewed sections
    const productGridSection = target.closest('#ProductGridContainer, .x-section-product-grid, #items-grid.product-grid, .recently-viewed-products, .section-recently-viewed, #shopify-section-recently-viewed');
    if (!productGridSection) return null;

    const card = target.closest('.card-product, .grid-item, .recently-viewed-card, [class*="card-product"]');
    if (!card) return null;

    // Exclude text / info / details area below image
    if (target.closest('.card-info, .card__content, .product-info, .x-card-price, .below-image, .bottom-card, .recently-viewed-card-info')) {
      return null;
    }

    // Identify the image container
    const imageWrapper = target.closest(
      'a.link-product-variant:not(.x-card-title), .recently-viewed-img-link, .card-product-img, .media-slide, picture, .x-splide'
    ) || card.querySelector('a.link-product-variant:not(.x-card-title), .recently-viewed-img-link');

    if (!imageWrapper) return null;

    // Check that target is inside imageWrapper or target is the imageWrapper
    if (target !== imageWrapper && !imageWrapper.contains(target)) return null;

    const gridItem = card.closest('.grid-item, .recently-viewed-item');
    const img = target.tagName === 'IMG' ? target : imageWrapper.querySelector('img');

    return { card, gridItem, imageWrapper, img };
  };

  const removeHoverClasses = (ctx) => {
    if (!ctx) return;
    HOVER_CLASSES.forEach((cls) => {
      ctx.card?.classList.remove(cls);
      ctx.gridItem?.classList.remove(cls);
      ctx.imageWrapper?.classList.remove(cls);
      ctx.img?.classList.remove(cls);
    });
    ctx.card?.removeAttribute('data-image-hovered');
    ctx.imageWrapper?.removeAttribute('data-image-hovered');
  };

  const addHoverClasses = (ctx) => {
    if (!ctx) return;
    HOVER_CLASSES.forEach((cls) => {
      ctx.card?.classList.add(cls);
      ctx.gridItem?.classList.add(cls);
      ctx.imageWrapper?.classList.add(cls);
      ctx.img?.classList.add(cls);
    });
    ctx.card?.setAttribute('data-image-hovered', 'true');
    ctx.imageWrapper?.setAttribute('data-image-hovered', 'true');
  };

  const handlePointerEnter = (e) => {
    // Avoid touch sticking on mobile devices
    if (e.pointerType === 'touch') return;

    const ctx = getImageContext(e.target);

    if (ctx) {
      if (activeContext && activeContext.imageWrapper === ctx.imageWrapper) {
        // Still inside the same image wrapper
        return;
      }
      if (activeContext) {
        removeHoverClasses(activeContext);
      }
      activeContext = ctx;
      addHoverClasses(activeContext);
    } else if (activeContext) {
      if (e.relatedTarget && activeContext.imageWrapper && activeContext.imageWrapper.contains(e.relatedTarget)) {
        return;
      }
      removeHoverClasses(activeContext);
      activeContext = null;
    }
  };

  const handlePointerLeave = (e) => {
    if (!activeContext) return;

    // If relatedTarget is still inside the current imageWrapper, don't remove
    const related = e.relatedTarget;
    if (related && activeContext.imageWrapper && activeContext.imageWrapper.contains(related)) {
      return;
    }

    // Moving completely outside the image wrapper
    removeHoverClasses(activeContext);
    activeContext = null;
  };

  // Attach pointer events for smooth and fast reaction
  document.addEventListener('pointerover', handlePointerEnter, { passive: true });
  document.addEventListener('pointerout', handlePointerLeave, { passive: true });

  // Safety: If cursor leaves document/window entirely, clear immediately
  document.addEventListener('mouseleave', () => {
    if (activeContext) {
      removeHoverClasses(activeContext);
      activeContext = null;
    }
  }, { passive: true });

  window.addEventListener('blur', () => {
    if (activeContext) {
      removeHoverClasses(activeContext);
      activeContext = null;
    }
  });

  // Safety: If collection filter updates or DOM reloads via AJAX
  document.addEventListener('shopify:section:load', () => {
    if (activeContext) {
      removeHoverClasses(activeContext);
      activeContext = null;
    }
  });
})();







/* Ensure sticky_header_css is reliably added to sort & filter bar on both mobile and desktop */
(function() {
  const updateStickyFilter = () => {
    const filterDiv = document.getElementById('header-filter');
    if (!filterDiv) return;

    const header = document.getElementById('sticky-header-content') || document.querySelector('.section-header') || document.getElementById('x-header-container');
    let headerBottom = 0;
    if (header) {
      const rect = header.getBoundingClientRect();
      headerBottom = rect.height > 0 ? Math.max(rect.bottom, 0) : 0;
    }

    const computedTop = parseFloat(window.getComputedStyle(filterDiv).top);
    const stickyThreshold = !isNaN(computedTop) && computedTop >= 0 ? Math.max(headerBottom, computedTop) : headerBottom;
    const filterRect = filterDiv.getBoundingClientRect();
    const isSticky = window.scrollY > 10 && filterRect.top <= (stickyThreshold + 4);

    filterDiv.classList.toggle('sticky_header_css', isSticky);
    const wrapper = filterDiv.querySelector('#FacetsWrapperDesktop');
    if (wrapper) {
      wrapper.classList.toggle('sticky_header_css', isSticky);
    }
  };

  window.addEventListener('scroll', updateStickyFilter, { passive: true });
  window.addEventListener('resize', updateStickyFilter, { passive: true });
  document.addEventListener('DOMContentLoaded', updateStickyFilter);
  document.addEventListener('shopify:section:load', updateStickyFilter);
  document.addEventListener('eurus:sticky-header-moved', updateStickyFilter);
})();

/* Round all site prices to whole numbers without decimals (e.g. 65.00 -> 65, 65.40 -> 65, 65.80 -> 66) */
(function() {
  const PRICE_REGEX = /(\$|CAD\$?\s*|USD\$?\s*|€\s*|£\s*)([0-9]{1,3}(?:,[0-9]{3})*|[0-9]+)\.([0-9]{2})(?![0-9])/g;
  const STANDALONE_PRICE_REGEX = /^(\s*)([0-9]{1,3}(?:,[0-9]{3})*|[0-9]+)\.([0-9]{2})(\s*)$/;
  const PRICE_PARENT_SELECTOR = '.price, .price-sale, .price-compare, .unit-price, .price-item, .price-preview, [data-price], #total-price, .total-price, .custom-price, .aamra-sta-sale-price, .aamra-sta-compare-price, .saved-amount, .badges-tiers-price';

  function roundPriceText(text, isPriceElement) {
    if (!text || typeof text !== 'string') return text;
    let res = text.replace(PRICE_REGEX, function(match, prefix, dollarsStr, centsStr) {
      const dollars = parseInt(dollarsStr.replace(/,/g, ''), 10);
      const cents = parseInt(centsStr, 10);
      if (isNaN(dollars) || isNaN(cents)) return match;
      const roundedDollars = cents >= 50 ? dollars + 1 : dollars;
      const formatted = roundedDollars.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return prefix + formatted;
    });

    if (isPriceElement && STANDALONE_PRICE_REGEX.test(res)) {
      res = res.replace(STANDALONE_PRICE_REGEX, function(match, prefix, dollarsStr, centsStr, suffix) {
        const dollars = parseInt(dollarsStr.replace(/,/g, ''), 10);
        const cents = parseInt(centsStr, 10);
        if (isNaN(dollars) || isNaN(cents)) return match;
        const roundedDollars = cents >= 50 ? dollars + 1 : dollars;
        const formatted = roundedDollars.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return prefix + formatted + suffix;
      });
    }

    return res;
  }

  let isCleaning = false;
  function cleanPriceNodes(root) {
    if (isCleaning) return;
    if (!root) root = document.body;
    if (!root) return;

    isCleaning = true;
    try {
      const walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            if (!node.nodeValue || !node.nodeValue.includes('.')) {
              return NodeFilter.FILTER_REJECT;
            }
            const parent = node.parentElement;
            if (!parent) return NodeFilter.FILTER_REJECT;
            const tag = parent.tagName;
            if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA' || tag === 'INPUT' || tag === 'OPTION') {
              return NodeFilter.FILTER_REJECT;
            }
            if (parent.closest('script, style, textarea, input[type="hidden"]')) {
              return NodeFilter.FILTER_REJECT;
            }
            return NodeFilter.FILTER_ACCEPT;
          }
        }
      );

      const nodesToUpdate = [];
      let currentNode;
      while ((currentNode = walker.nextNode())) {
        const parent = currentNode.parentElement;
        const isPriceElement = parent ? !!parent.closest(PRICE_PARENT_SELECTOR) : false;
        PRICE_REGEX.lastIndex = 0;
        if (PRICE_REGEX.test(currentNode.nodeValue) || (isPriceElement && STANDALONE_PRICE_REGEX.test(currentNode.nodeValue))) {
          nodesToUpdate.push({ node: currentNode, isPriceElement: isPriceElement });
        }
      }

      for (let i = 0; i < nodesToUpdate.length; i++) {
        const item = nodesToUpdate[i];
        const newText = roundPriceText(item.node.nodeValue, item.isPriceElement);
        if (newText !== item.node.nodeValue) {
          item.node.nodeValue = newText;
        }
      }
    } finally {
      isCleaning = false;
    }
  }

  // Initial runs
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => cleanPriceNodes());
  } else {
    cleanPriceNodes();
  }

  // Fast runs on various lifecycle events
  window.addEventListener('load', () => cleanPriceNodes());
  document.addEventListener('shopify:section:load', () => cleanPriceNodes());
  document.addEventListener('shopify:section:select', () => cleanPriceNodes());
  document.addEventListener('eurus:cart:updated', () => cleanPriceNodes());
  document.addEventListener('cart:updated', () => cleanPriceNodes());

  // MutationObserver for dynamic updates (pagination, swatches, quickview, drawer)
  let timeoutId = null;
  const observer = new MutationObserver((mutations) => {
    if (isCleaning) return;
    let shouldClean = false;
    for (let i = 0; i < mutations.length; i++) {
      const mut = mutations[i];
      if (mut.type === 'characterData') {
        if (mut.target && mut.target.nodeValue && mut.target.nodeValue.includes('.')) {
          PRICE_REGEX.lastIndex = 0;
          if (PRICE_REGEX.test(mut.target.nodeValue)) {
            shouldClean = true;
            break;
          }
        }
      } else if (mut.type === 'childList' && mut.addedNodes.length > 0) {
        shouldClean = true;
        break;
      }
    }

    if (shouldClean) {
      if (timeoutId) cancelAnimationFrame(timeoutId);
      timeoutId = requestAnimationFrame(() => {
        cleanPriceNodes();
      });
    }
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }
})();










/* Condition: If wishlist count is 0 or empty, do not show badge; if > 0, show count */
(() => {
  const updateWishlistCountVisibility = () => {
    const badges = document.querySelectorAll('.wishlist-h-count, .wishlist-total-count');
    badges.forEach((badge) => {
      const text = badge.textContent.trim();
      const count = parseInt(text, 10);
      const dataTotal = parseInt(badge.getAttribute('data-total'), 10);

      const total = !isNaN(count) ? count : (!isNaN(dataTotal) ? dataTotal : 0);

      if (total > 0) {
        badge.style.removeProperty('display');
        badge.classList.remove('hidden');
      } else {
        badge.style.setProperty('display', 'none', 'important');
        badge.classList.add('hidden');
      }
    });
  };

  // Run on initial load and lifecycle events
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateWishlistCountVisibility);
  } else {
    updateWishlistCountVisibility();
  }

  window.addEventListener('load', updateWishlistCountVisibility);
  document.addEventListener('shopify:section:load', updateWishlistCountVisibility);
  document.addEventListener('wishlist-engine:render', updateWishlistCountVisibility);
  document.addEventListener('wishlist:updated', updateWishlistCountVisibility);
  window.addEventListener('storage', updateWishlistCountVisibility);

  // Observe text mutations so whenever the Wishlist app updates the count, evaluate condition
  const observer = new MutationObserver(() => {
    updateWishlistCountVisibility();
  });

  const attachObservers = () => {
    const badges = document.querySelectorAll('.wishlist-h-count, .wishlist-total-count');
    badges.forEach((b) => {
      observer.observe(b, {
        childList: true,
        characterData: true,
        subtree: true
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObservers);
  } else {
    attachObservers();
  }
})();

// Back in stock: the PDP Notify Me box also registers the customer with the Kbite app, then submits the contact form as before
(() => {
  const MAX_WAIT = 4000;

  const signupFinished = () => performance.getEntriesByType('resource').some((r) => r.name.includes('/subscribers/campaignMapping'));

  const waitForSignup = () => new Promise((resolve) => {
    const start = Date.now();
    const check = () => {
      if (signupFinished() || Date.now() - start > MAX_WAIT) resolve();
      else setTimeout(check, 100);
    };
    check();
  });

  document.addEventListener('click', async (e) => {
    const submitButton = e.target.closest && e.target.closest('.aamra-notify-btn');
    const form = submitButton && submitButton.form;
    if (!form || form.dataset.kbiteDone || !form.checkValidity()) return;
    const app = window.initVar;
    const appButton = document.querySelector('[gw-stock-fulfilled]');
    const emailInput = form.querySelector('input[type="email"]');
    // Without the app the contact form still submits, so the request is never lost
    if (!app || !app.stockFulFilledEmailCampaign || !appButton || !emailInput) return;

    e.preventDefault();
    form.dataset.kbiteDone = '1';
    try {
      app.clickedProductId = Number(appButton.getAttribute(app.dataProductId));
      app.clickedProductHandle = appButton.getAttribute(app.dataProductHandle);
      app.clickedVariantId = Number(appButton.getAttribute(app.dataVariantId));
      await app.campaignPopUpNotifyButtonClicked(app.stockWidget.popupSelector, app.stockFulFilledEmailCampaign.uniqueId, emailInput.value.trim(), false);
      await waitForSignup();
    } catch (err) {
      console.error('Back in stock signup failed', err);
    }
    form.requestSubmit(submitButton);
  }, true);
})();


/* ==========================================================================
   Aamra Card Swatch Hover Image
   - Cards always hover to the product's second photo, which belongs to the first colour
   - When a swatch changes the main image, hover shows the photo that follows it instead
   ========================================================================== */
(() => {
  const HOVER_IMG_SELECTOR = '.image-first-hover-slide-anm, .image-second-hover';
  const productRequests = new Map();

  const fileName = (src) => (src || '').split('?')[0].split('/').pop();

  const loadProduct = (handle) => {
    if (!productRequests.has(handle)) {
      productRequests.set(handle, fetch(`${window.Shopify.routes.root}products/${handle}.js`)
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null));
    }
    return productRequests.get(handle);
  };

  const updateHoverImage = async (preview) => {
    const card = preview.closest('[x-data*="xProductCard"]');
    const hoverImg = card?.querySelector(HOVER_IMG_SELECTOR);
    const handle = card?.querySelector('a[href*="/products/"]')?.getAttribute('href').match(/\/products\/([^/?#]+)/)?.[1];
    if (!hoverImg || !handle) return;

    const selected = fileName(preview.getAttribute('src'));
    const product = await loadProduct(handle);
    if (!product || fileName(preview.getAttribute('src')) !== selected) return;

    const images = product.media.filter((media) => media.media_type === 'image');
    const index = images.findIndex((media) => fileName(media.src) === selected);
    const next = index === -1 ? null : images[index + 1];
    if (!next) return;

    hoverImg.removeAttribute('srcset');
    hoverImg.setAttribute('loading', 'eager');
    hoverImg.setAttribute('src', `${next.src.split('?')[0]}?width=1500`);
  };

  new MutationObserver((mutations) => {
    mutations.forEach(({ target }) => {
      if (target.classList.contains('preview-img')) updateHoverImage(target);
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['src'] });
})();


/* ==========================================================================
   Aamra Product Row Arrows
   - Adds previous / next buttons to every .recently-viewed-scroller
   - Each click moves the row by one product; drag and swipe keep working
   - An arrow only shows when there is something to scroll to in that direction
   ========================================================================== */
(() => {
  const PREV_ICON = '<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="44" height="44" transform="translate(44) rotate(90)" fill="#211B13" fill-opacity="0.6"/><path d="M24.9427 27.8082C25.0007 27.8662 25.0468 27.9352 25.0782 28.011C25.1097 28.0869 25.1258 28.1682 25.1258 28.2503C25.1258 28.3325 25.1097 28.4138 25.0782 28.4897C25.0468 28.5655 25.0007 28.6345 24.9427 28.6925C24.8846 28.7506 24.8157 28.7967 24.7398 28.8281C24.6639 28.8595 24.5826 28.8757 24.5005 28.8757C24.4184 28.8757 24.3371 28.8595 24.2612 28.8281C24.1853 28.7967 24.1164 28.7506 24.0583 28.6925L17.8083 22.4425C17.7502 22.3845 17.7041 22.3156 17.6726 22.2397C17.6412 22.1638 17.625 22.0825 17.625 22.0003C17.625 21.9182 17.6412 21.8369 17.6726 21.761C17.7041 21.6851 17.7502 21.6162 17.8083 21.5582L24.0583 15.3082C24.1756 15.1909 24.3346 15.125 24.5005 15.125C24.6663 15.125 24.8254 15.1909 24.9427 15.3082C25.06 15.4254 25.1258 15.5845 25.1258 15.7503C25.1258 15.9162 25.06 16.0753 24.9427 16.1925L19.1341 22.0003L24.9427 27.8082Z" fill="#F0E9D6"/></svg>';
  const NEXT_ICON = '<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="44" height="44" transform="translate(44) rotate(90)" fill="#211B13" fill-opacity="0.6"/><path d="M26.1925 22.4425L19.9425 28.6925C19.8845 28.7506 19.8155 28.7967 19.7397 28.8281C19.6638 28.8595 19.5825 28.8757 19.5003 28.8757C19.4182 28.8757 19.3369 28.8595 19.261 28.8281C19.1852 28.7967 19.1162 28.7506 19.0582 28.6925C19.0001 28.6345 18.954 28.5655 18.9226 28.4897C18.8912 28.4138 18.875 28.3325 18.875 28.2503C18.875 28.1682 18.8912 28.0869 18.9226 28.011C18.954 27.9352 19.0001 27.8662 19.0582 27.8082L24.8668 22.0003L19.0582 16.1925C18.9409 16.0753 18.875 15.9162 18.875 15.7503C18.875 15.5845 18.9409 15.4254 19.0582 15.3082C19.1754 15.1909 19.3345 15.125 19.5003 15.125C19.6662 15.125 19.8253 15.1909 19.9425 15.3082L26.1925 21.5582C26.2506 21.6162 26.2967 21.6851 26.3282 21.761C26.3597 21.8369 26.3758 21.9182 26.3758 22.0003C26.3758 22.0825 26.3597 22.1638 26.3282 22.2397C26.2967 22.3156 26.2506 22.3845 26.1925 22.4425Z" fill="#F0E9D6"/></svg>';

  const createArrow = (direction, label, icon) => {
    const arrow = document.createElement('button');
    arrow.type = 'button';
    arrow.className = `aamra-row-arrow aamra-row-arrow--${direction}`;
    arrow.setAttribute('aria-label', label);
    arrow.hidden = true;
    arrow.innerHTML = icon;
    return arrow;
  };

  const setupArrows = (scroller) => {
    const wrapper = scroller.closest('.recently-viewed-scroller-wrapper');
    if (!wrapper) return;
    scroller.dataset.arrowsReady = 'true';

    const prev = createArrow('prev', 'Previous products', PREV_ICON);
    const next = createArrow('next', 'Next products', NEXT_ICON);
    wrapper.append(prev, next);

    // Keep the arrows centred on the product image, not on the whole card
    const update = () => {
      prev.hidden = scroller.scrollLeft <= 1;
      next.hidden = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 1;

      // Offsets ignore the cards' reveal animation; a card that has not laid out yet is re-measured by the observer
      const item = scroller.querySelector('.recently-viewed-item');
      const image = item?.querySelector('img');
      if (!image) return;
      resizeObserver.observe(image);
      if (!image.offsetHeight) return;
      wrapper.style.setProperty('--aamra-row-arrow-top', `${item.offsetTop + image.offsetHeight / 2}px`);
    };

    const slide = (direction) => {
      const item = scroller.querySelector('.recently-viewed-item');
      const gap = parseFloat(getComputedStyle(scroller).columnGap) || 0;
      const step = item ? item.offsetWidth + gap : scroller.clientWidth;
      scroller.scrollBy({ left: direction * step, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => slide(-1));
    next.addEventListener('click', () => slide(1));

    let updateScheduled = false;
    const scheduleUpdate = () => {
      if (updateScheduled) return;
      updateScheduled = true;
      requestAnimationFrame(() => {
        updateScheduled = false;
        update();
      });
    };

    scroller.addEventListener('scroll', scheduleUpdate, { passive: true });
    const resizeObserver = new ResizeObserver(scheduleUpdate);
    resizeObserver.observe(scroller);
    new MutationObserver(scheduleUpdate).observe(scroller, { childList: true });
    update();
  };

  // Recommendations and recently viewed render after page load
  let setupScheduled = false;
  const scheduleSetup = () => {
    if (setupScheduled) return;
    setupScheduled = true;
    requestAnimationFrame(() => {
      setupScheduled = false;
      document.querySelectorAll('.recently-viewed-scroller:not([data-arrows-ready])').forEach(setupArrows);
    });
  };

  scheduleSetup();
  new MutationObserver(scheduleSetup).observe(document.documentElement, { subtree: true, childList: true });
})();

// Dynamic Globo App Color Swatch Integration for Quick View
(function() {
  window._globoAppColorCache = window._globoAppColorCache || {};

  // Extract all swatches generated by the Globo App across the page
  function collectGloboAppSwatches() {
    // 1. Check Globo global runtime objects
    try {
      if (window.Globo && window.Globo.swatch) {
        var gColors = window.Globo.swatch.colors || window.Globo.swatch.options || (window.Globo.swatch.settings && window.Globo.swatch.settings.colors);
        if (gColors && typeof gColors === 'object') {
          Object.keys(gColors).forEach(function(key) {
            var val = gColors[key];
            if (typeof val === 'string') {
              window._globoAppColorCache[key.trim().toLowerCase()] = val;
            } else if (val && val.background) {
              window._globoAppColorCache[key.trim().toLowerCase()] = val.background;
            }
          });
        }
      }
    } catch(e) {}

    // 2. Read all DOM swatches generated by Globo App (.swatches-globo--list)
    var globoItems = document.querySelectorAll('.swatches-globo--list li');
    globoItems.forEach(function(li) {
      var colorName = (
        li.getAttribute('title') ||
        li.getAttribute('data-title') ||
        li.getAttribute('option-value') ||
        li.getAttribute('data-value') ||
        (li.querySelector('input') && (li.querySelector('input').value || li.querySelector('input').getAttribute('data-title'))) ||
        ''
      ).trim().toLowerCase();

      if (!colorName) return;

      var bgEl = li.querySelector('.g-swatch-item, .g-swatch, label, span') || li;
      var bg = bgEl.style.background || bgEl.style.backgroundImage || bgEl.style.backgroundColor;

      if (!bg || bg === 'none') {
        var comp = window.getComputedStyle(bgEl);
        bg = comp.backgroundImage && comp.backgroundImage !== 'none' ? comp.backgroundImage : comp.backgroundColor;
      }

      if (bg && bg !== 'none' && !bg.includes('rgba(0, 0, 0, 0)')) {
        window._globoAppColorCache[colorName] = bg;
      }
    });
  }

  // Apply App colors dynamically to Quick View swatches
  function applyAppColorsToQuickView() {
    collectGloboAppSwatches();

    var qv = document.getElementById('QuickView');
    if (!qv) return;

    var swatches = qv.querySelectorAll('label.color-watches');
    if (!swatches.length) return;

    // Check if the originating card that triggered Quick View has its own Globo swatches
    var originatingCard = null;
    try {
      if (window.Alpine && window.Alpine.store('xQuickView') && window.Alpine.store('xQuickView').buttonQuickView) {
        originatingCard = window.Alpine.store('xQuickView').buttonQuickView.closest('.grid-item, .card-product, .card');
      }
    } catch(e) {}

    var cardGloboMap = {};
    if (originatingCard) {
      var cardItems = originatingCard.querySelectorAll('.swatches-globo--list li');
      cardItems.forEach(function(li) {
        var name = (
          li.getAttribute('title') ||
          li.getAttribute('data-title') ||
          li.getAttribute('option-value') ||
          li.getAttribute('data-value') ||
          (li.querySelector('input') && (li.querySelector('input').value || li.querySelector('input').getAttribute('data-title'))) ||
          ''
        ).trim().toLowerCase();

        var bgEl = li.querySelector('.g-swatch-item, .g-swatch, label, span') || li;
        var bg = bgEl.style.background || bgEl.style.backgroundImage || bgEl.style.backgroundColor;
        if (!bg || bg === 'none') {
          var comp = window.getComputedStyle(bgEl);
          bg = comp.backgroundImage && comp.backgroundImage !== 'none' ? comp.backgroundImage : comp.backgroundColor;
        }
        if (name && bg && bg !== 'none') {
          cardGloboMap[name] = bg;
          window._globoAppColorCache[name] = bg;
        }
      });
    }

    swatches.forEach(function(sw) {
      var colorName = (
        sw.getAttribute('aria-label') ||
        sw.getAttribute('data-option-value') ||
        sw.getAttribute('data-color') ||
        sw.textContent ||
        ''
      ).trim().toLowerCase();

      var appBg = cardGloboMap[colorName] || window._globoAppColorCache[colorName];
      if (appBg) {
        sw.style.setProperty('background', appBg, 'important');
        sw.style.setProperty('background-size', 'cover', 'important');
        sw.style.setProperty('background-position', 'center', 'important');
      }
    });
  }

  // Events: when Globo finishes loading on collection
  window.addEventListener('Globo.swatch.collection.loaded', function() {
    collectGloboAppSwatches();
    applyAppColorsToQuickView();
  });
  window.addEventListener('globoFilterRenderCompleted', function() {
    collectGloboAppSwatches();
    applyAppColorsToQuickView();
  });

  // Events: when Quick View opens or loads
  document.addEventListener('eurus:quickview:loaded', function() {
    applyAppColorsToQuickView();
    setTimeout(applyAppColorsToQuickView, 50);
    setTimeout(applyAppColorsToQuickView, 200);
  });

  // Listen to Quick View clicks directly on page
  document.addEventListener('click', function(e) {
    if (e.target.closest('.quick-view-container, .button--quickview, .label-btn-quickview')) {
      setTimeout(applyAppColorsToQuickView, 100);
      setTimeout(applyAppColorsToQuickView, 300);
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    collectGloboAppSwatches();

    var qvContent = document.getElementById('quickview-product-content');
    if (qvContent) {
      new MutationObserver(function() {
        applyAppColorsToQuickView();
      }).observe(qvContent, { childList: true, subtree: true });
    }
  });
})();

